import restApi from "@plannel/services/utils/rest-api";

const getDashboards = () => {
  return restApi.get("/api/quicksight/dashboards");
};

const getEmbedUrl = (dashboardId) => {
  return restApi.get("/api/quicksight/embed-url", { params: { dashboardId } });
};

const quickSightService = {
  getDashboards,
  getEmbedUrl,
};

export default quickSightService;
